export default __webpack_public_path__ + "static/media/Manitowoc.9eb6db02.svg";